import { track } from '@vercel/analytics'

/** The handful of things worth counting on a one-screen portfolio. */
export type EventName = 'toss' | 'about_open' | 'watch_me_work' | 'link_click' | 'new_best' | 'star_ring'

/**
 * A custom event for Vercel Web Analytics. Production only: in development the beacon has
 * nowhere to go, and the console stays quiet.
 */
export function trackEvent(name: EventName, props?: Record<string, string | number | boolean>) {
  if (!import.meta.env.PROD) return
  try {
    track(name, props)
  } catch {
    // Analytics must never break the page.
  }
}
